export const FILTER_TYPES = {
	NONE: '',
	CONTAGIOUS: 'contagious',
	BY_ATTRIBUTE: 'by attribute'
}